<template>
    <svg id="megaphone" viewBox="0 0 185 185" xmlns="http://www.w3.org/2000/svg">
        <g id="Layer_2" data-name="Layer 2">
            <g id="Layer_1-2" data-name="Layer 1">
                <circle id="Ellipse_3-2" class="cls-11" cx="92.5" cy="92.5" data-name="Ellipse 3-2"
                        r="92.5"/>
                <g id="Group_1940" data-name="Group 1940" transform="translate(32.877 38.653)"
                   xmlns="http://www.w3.org/2000/svg">
                    <path id="Path_506"
                          d="M2413.115,710.35l-6.241-17.148a3.619,3.619,0,0,0-3-2.4,3.362,3.362,0,0,0-3.2,1.516l-1.723,2.524a82.765,82.765,0,0,1-40.064,31.128l-4.143,1.508a14.821,14.821,0,0,0,8.741,28.285l16.442,25.183a8.2,8.2,0,0,0,14.008-8.515l-4.053-7.151a7.6,7.6,0,0,0,3.438-8.338,6.544,6.544,0,0,0-.8-2.037l-3.067-5.706a82.264,82.264,0,0,1,30.248,2.69l2.959.827a3.358,3.358,0,0,0,3.423-.894,3.626,3.626,0,0,0,.75-3.775L2420.6,730.9a11.51,11.51,0,0,0-7.48-20.552Zm-63.524,34.772a10.882,10.882,0,0,1,6.5-13.947l4.143-1.508q4-1.457,7.86-3.31l7.732,21.243q-4.027,1.033-7.941,2.446h0l-.168.061-.007,0-4.174,1.519A10.9,10.9,0,0,1,2349.591,745.122Zm41.213,32.822a4.262,4.262,0,0,1-7.57.854l-15.907-24.358,1.74-.633a82.851,82.851,0,0,1,8.38-2.554l13.065,23.116A4.253,4.253,0,0,1,2390.8,777.944Zm-1.336-20.2a3.76,3.76,0,0,1-1.521,4.1l-6.481-11.482q1.89-.37,3.794-.653l3.817,7.1.053.093A2.675,2.675,0,0,1,2389.468,757.744Zm33.408-9.06-2.112-.59a86.243,86.243,0,0,0-34.962-2.44q-3.07.413-6.11,1.048l-8.06-22.143q2.732-1.468,5.354-3.126a86.236,86.236,0,0,0,25.219-24.375l1.226-1.795Zm-3.74-21.789-4.563-12.536a7.579,7.579,0,0,1,4.563,12.536Z"
                          data-name="Path 506"
                          fill="#fff" transform="translate(-2344.988 -676.977)"/>
                    <path id="Path_507"
                          d="M3091.585,804.039l-22.844,8.314a1.969,1.969,0,0,0,1.347,3.7l22.844-8.314a1.969,1.969,0,0,0-1.347-3.7Z"
                          data-name="Path 507"
                          fill="#fff" transform="translate(-2980.991 -776.58)"/>
                    <path id="Path_508"
                          d="M3127.361,1008.05l-24.977-7.071a1.969,1.969,0,0,0-1.073,3.789l24.977,7.071a1.969,1.969,0,0,0,1.073-3.789Z"
                          data-name="Path 508"
                          fill="#fff" transform="translate(-3009.542 -949.992)"/>
                    <path id="Path_509"
                          d="M3012.979,600.743a1.96,1.96,0,0,0,.953-.743l14.589-21.472a1.969,1.969,0,1,0-3.257-2.213l-14.589,21.472a1.969,1.969,0,0,0,2.3,2.956Z"
                          data-name="Path 509"
                          fill="#fff" transform="translate(-2930.714 -575.452)"/>
                </g>
            </g>
        </g>
    </svg>


</template>

<script>
export default {
    name: "svg-events"
}
</script>

<style lang="scss" scoped>
.cls-11 {
    fill: #A6CE38;
}

.cls-2 {
    fill: #fff;
}

svg {
    transition: 200ms all ease-in-out;
    &:hover {
        transform: scale(1.1);
    }
}

</style>
